<template>
    <Tooltip
        placement="bottom"
        :title="$t('clickToCopy')"
    >
        <Tag
            class="m-0"
            @click="copy"
        >
            {{ apiKey }}
        </Tag>
    </Tooltip>
</template>

<script>
import { Tag, Tooltip } from 'ant-design-vue';

export default {
    components: {
        Tag,
        Tooltip,
    },
    props: {
        apiKey: {
            type: String,
            required: true,
        },
    },
    methods: {
        copy() {
            this.$writeToClipboard(this.apiKey);
            this.$notification.success({ message: this.$t('copiedToClipboard') });
        },
    },
};
</script>

<style>

</style>